/**
 * AOI Query Keys
 *
 * Centralized query key factory for React Query cache management
 * Following React Query best practices for key management
 */

import type { AOIListParams } from './aoi.api';

export const aoiQueryKeys = {
    // Base key for all AOI-related queries
    all: ['aoi'] as const,

    // List queries
    lists: () => [...aoiQueryKeys.all, 'list'] as const,
    list: (params?: AOIListParams) => [...aoiQueryKeys.lists(), params] as const,

    // Detail queries
    details: () => [...aoiQueryKeys.all, 'detail'] as const,
    detail: (id: string) => [...aoiQueryKeys.details(), id] as const,
};
